import React, { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  handleReset,
  setErrorMessage,
  setResetOtpScreen,
  setMobileNumber,
} from "./cl_ResetSlice";
const Reset = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [numberLength, setNumberLength] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [handleVerified, setHandleVerified] = useState(false);
  const numRegex = /^[0-9]+$/;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const resetMobNum = searchParams.get("mbNum");
  const { errorMessage, isLoading, mobileNumber } = useSelector(
    (state) => state.resetPage
  );
  useEffect(() => {
    if (mobileNumber?.charAt(0) == "0") {
      setNumberLength(true);
    } else {
      setNumberLength(false);
    }
  }, [mobileNumber]);
  useEffect(() => {
    if (resetMobNum) {
      dispatch(setMobileNumber(resetMobNum));
    } else {
      // dispatch(setMobileNumber(""));
    }
    dispatch(setErrorMessage(""));
  }, []);

  const handleMobileChange = (event) => {
    const number = event.target.value;
    if (numRegex.test(number) || number === "") {
      dispatch(setMobileNumber(number));
      setErrorMsg("");
      number.length === 10 ? setHandleVerified(true) : setHandleVerified(false);
      setErrorMsg("");
      dispatch(setErrorMessage(""));
    }
  };

  const handleProceedButton = () => {
    if (isLoading) return;

    if (mobileNumber.length < 9) {
      setErrorMsg("Please enter a valid 9 digit Mobile Number");
    } else if (
      numberLength &&
      mobileNumber?.charAt(1) !== "7" &&
      mobileNumber?.charAt(1) !== "1"
    ) {
      setErrorMsg("Please enter a valid 9-digit Mobile Number");
    } else if (
      !numberLength &&
      mobileNumber?.charAt(0) !== "7" &&
      mobileNumber?.charAt(0) !== "1"
    ) {
      setErrorMsg("Please enter a valid 9-digit Mobile Number");
    } else {
      setErrorMsg("");
      dispatch(setResetOtpScreen(true));
      dispatch(handleReset(mobileNumber, navigate));
    }
  };
  useEffect(() => {
    // dispatch(setMobileNumber(""));
    setErrorMsg("");
    dispatch(setErrorMessage(""));
  }, []);
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      !isLoading && handleProceedButton();
    }
  };
  return (
    <>
      <div id="SB-resetPIN-container">
        <div className="SB-loginRegister-title">Reset PIN</div>
        <div className="SB-loginRegister-form">
          <div className="SB-form-group">
            <div className="SB-form-label">Mobile Number</div>
            <div className="SB-form-control-group SB-mobileNumberField">
              <div className="SB-form-addon SB-addon-left">
                <div className="SB-regionCode">+254</div>
              </div>
              <div className="SB-form-control">
                <input
                  type={"tel"}
                  placeholder="Enter Your Mobile Number"
                  onChange={handleMobileChange}
                  value={mobileNumber}
                  maxLength={numberLength ? 10 : 9}
                  onKeyPress={handleKeyPress}
                />
              </div>
              {/* {handleVerified ? (
                                <div
                                    className={"SB-form-addon  SB-addon-right"}
                                >
                                    <div className=" SB-iconSVG SB-iconVerified">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                            <use
                                                // xlinkHref={`${icons}#${"icon-check"}`}
                                            />
                                        </svg>
                                    </div>
                                </div>
                            ) : null} */}
            </div>
            <div className="SB-form-errorMsg">
              <span>{errorMsg}</span>
            </div>
          </div>
          {errorMessage && (
            <div className="SB-form-errorMsg text-center">
              <span>
                {errorMessage === "OTP_EXPIRED" ? "In-Valid OTP" : errorMessage}
              </span>
            </div>
          )}
          <div className="text-center">
            <button
              className="btn SB-login SB-btnSecondary active SB-btnLarge"
              id="SB-resetPIN-proceedBtn"
              onClick={handleProceedButton}
            >
              {!isLoading ? (
                <div className="SB-btnTxt">Proceed</div>
              ) : (
                <div className="SB-loader-container">
                  <div className="SB-loader"></div>
                </div>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reset;
